import { emitClickEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex) => {
  const { labels } = widgetTracking;

  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: 'clicked',
    labels: {
      ...labels,
      promo_FeatureNumber: ['99']
    }
  };
};
const buildProductTrackingData = (productTracking) => ({
  ...productTracking,
  status: 'clicked'
});

export default (
  widgetTracking,
  additionalWidgetClickTracking,
  productTracking,
  additionalProductClickTracking,
  featureIndex
) => {
  const event = {
    name: 'click',
    features: [
      buildWidgetTrackingData(widgetTracking, featureIndex),
      buildProductTrackingData(productTracking)
    ]
  };

  const additionalClickTrackingLabels = {
    ...additionalWidgetClickTracking,
    'wk.promo_AttributionFeature': ['Bundles_DetailView'],
    ...additionalProductClickTracking
  };
  emitClickEvent(event, { promo_Click: widgetTracking.name }, additionalClickTrackingLabels);
};
